import React from "react";
import {
  faArrowAltCircleLeft,
  faFileImport,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import {
  setFile,
  setStep,
} from "../../../store/customeUplaod/customeUploadSlice";

export const UploadImage = ({
  acceptFile,
  children,
  onFileUpload,
  headerText,
  handleBack,
  handleGenerate,
  maxSize = 50,
  directUpload,
}) => {
  const dispatch = useDispatch();
  const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];
  const step = useSelector((state) => state.uploder);
  const handleButtonClick = () => {
    if (step?.step === "instruction") {
      // If in the "upload" step, switch to the "generate" step
      dispatch(setStep("upload"));
    } else if (step?.step === "upload") {
      if (!step?.file) {
        return;
      }
      // If in the "upload" step, switch to the "generate" step
      dispatch(setStep("generate"));
    } else if (step?.step === "generate") {
      // If in the "generate" step, switch to the "done" step
      dispatch(setStep("done"));
      if (handleGenerate) {
        return handleGenerate();
      }
      // return onFileUpload ? onFileUpload(file) : imageUpload();
    } else {
      if (handleBack) {
        handleBack();
      }
    }
  };
  const handleChange = (file) => {
    dispatch(setFile(file));
    dispatch(setStep("generate"));
  };

  return (
    <div className="flex flex-col w-full h-full">
      <div className="w-full bg-gradient-to-b from-gray-300 to-white to-25%">
        <div className="flex p-3 justify-start items-center cursor-pointer">
          <FontAwesomeIcon
            icon={faArrowAltCircleLeft}
            className="mr-2 text-gray-800"
            onClick={handleBack}
          />
          <h1>{headerText}</h1>
        </div>
      </div>
      <div className="m-4 flex flex-col justify-center gap-5">
        <div
          key={step?.step}
          className="h-full border border-gray-300 bg-white flex items-center justify-center rounded-md overflow-auto"
        >
          {step?.step === "upload" && (
            <div className="m-5 border border-dashed border-gray-300 h-136 w-468 flex flex-col items-center justify-center rounded-md">
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={acceptFile || fileTypes}
                maxSize={maxSize}
                children={
                  <>
                    <div className="p-3 flex flex-col justify-center items-center gap-5 cursor-pointer">
                      {" "}
                      <FontAwesomeIcon
                        icon={faFileImport}
                        className="mr-2 text-gray-800"
                      />
                      <span className="text-sm font-semibold text-gray-600">
                        Drag and Drop File Here or <a>Choose File</a>
                      </span>
                      <span className="text-sm font-semibold text-gray-600">
                        {maxSize} Mb max file size
                      </span>
                    </div>
                  </>
                }
              />
            </div>
          )}
          {step?.step === "generate" &&
            (children ? (
              typeof children === "function" ? (
                children(step?.file)
              ) : (
                children
              )
            ) : (
              <img
                height={230}
                width={230}
                src={step?.file ? URL.createObjectURL(step?.file) : null}
                alt={""}
              />
            ))}
          {step?.step === "done" && (
            <div className="p-8 flex flex-col items-center justify-center gap-2 flex-wrap">
              <img
                src="/tool/dashboard/static/images/icons/tools/congratulation.svg"
                alt="congratulations"
              />
              <span className="">Congratulations!!</span>
              <span className="text-sm font-semibold text-gray-600">
                Your image has been uploaded. Please wait for the image to be
                approved by our team. You will get a message soon on your
                registered e-mail ID.
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="mr-3 flex justify-end">
        <button
          className={`bg-black text-white
        hover:bg-gray-400
        text-gray-800
        font-bold
        py-2
        px-4
        rounded
        inline-flex
        items-center ${
          step?.step === "upload" && !step?.file
            ? "opacity-50 cursor-not-allowed"
            : "opacity-100"
        }`}
          onClick={handleButtonClick}
        >
          {step?.step === "instruction"
            ? "Agree"
            : step?.step === "upload" && !directUpload
            ? "Upload"
            : step?.step === "generate" || directUpload
            ? "Generate"
            : "Done"}
        </button>
      </div>
    </div>
  );
};
